// 共通タブメニュー内容切り替え
$(function () {
  $('.js-tab-item').click(function () {
    $(this).siblings().removeClass('current')
    $(this).addClass('current')
    let href = $(this).attr('href')
    $('.js-list-' + href).addClass('show')
    $('.js-list')
      .not('.js-list-' + href)
      .removeClass('show')
    return false
  })
})
